import { Grid } from '@mui/material';
import { useState } from 'react';
import { AgreementPricesPopperButton } from '../components/AgreementPricesPopperButton';

type Props = {
    value: string;
    agreementPriceIds: number[];
    priceType: 'in' | 'ext';
    currentAgreementId?: number;
};

export const AgreementCell = ({ value, agreementPriceIds, priceType, currentAgreementId }: Props) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <Grid container direction="row" spacing={0} justifyContent="space-between">
            <Grid item>{value}</Grid>
            <Grid item>
                {agreementPriceIds.length > 0 && (
                    <AgreementPricesPopperButton
                        agreementPriceIds={agreementPriceIds}
                        open={isOpen}
                        setOpen={setIsOpen}
                        priceType={priceType}
                        currentAgreementId={currentAgreementId}
                    />
                )}
            </Grid>
        </Grid>
    );
};
